import { Col, Container, Row } from "react-bootstrap";
import PageTitleBar from "../../Components/Site/PageTitleBar";
import { Link } from "react-router-dom";

const Terms = (props) => {

  return (
    <>

      <PageTitleBar title="Terms & Conditions" subTitle="Last Updated on 27th August 2025" />

      <section id="privacy-policy" className="section-pad">
        <Container>

          <Row>
            <Col>
              <div className="cms-content">

                <h2>1. Acceptance of Terms</h2>
                <p>By accessing or using Joyfullminds.com (“Website”) and our online/mobile services (collectively, the “Services”), you agree to be bound by these Terms &amp; Conditions (“Terms”). If you do not agree, you must not use the Services.</p>

                <h2>2. About Joyfullminds</h2>
                <p>Joyfullminds provides counseling, therapy, coaching, and wellness-related services through qualified professionals. Joyfullminds is not a hospital or emergency-care provider.</p>

                <h2>3. Eligibility &amp; Account</h2>
                <ul>
                  <li>You must be at least 18 years old to create an account. Minors may use the Services only with verifiable parental/guardian consent and completion of any required consent forms.</li>
                  <li>You agree to provide accurate, current, and complete information and to keep your login credentials confidential. You are responsible for all activity under your account.</li>
                </ul>

                <h2>4. Health &amp; Safety Disclaimer</h2>
                <p>The Services are for mental health and wellness support. They do not replace in-person clinical diagnosis, emergency care, or medical treatment. If you are in crisis or at risk of harm, contact local emergency services immediately.</p>

                <h2>5. Booking, Scheduling &amp; Attendance</h2>
                <ul>
                  <li>Session bookings are subject to availability of assigned professionals.</li>
                  <li>Late arrivals may result in shorter sessions without extension or refund. No-shows are treated as completed sessions.</li>
                  <li>For cancellations, rescheduling, or refunds, see our <Link to="/refund-cancellation-policy">Refund &amp; Cancellation Policy</Link>.</li>
                </ul>

                <h2>6. Payments &amp; Pricing</h2>
                <ul>
                  <li>Prices, taxes, and offers may change at any time. Payments may be processed by third-party gateways subject to their terms.</li>
                  <li>Refunds are governed exclusively by our <Link to="/refund-cancellation-policy">Refund &amp; Cancellation Policy</Link>.</li>
                </ul>

                <h2>7. Professional Relationship</h2>
                <p>Engaging with our experts establishes a professional support relationship limited to the scope of Services offered through Joyfullminds. No outcomes are guaranteed.</p>

                <h2>8. Acceptable Use</h2>
                <ul>
                  <li>No unlawful, abusive, harassing, or harmful conduct.</li>
                  <li>No attempt to disrupt, reverse engineer, or gain unauthorized access to the Services.</li>
                  <li>No sharing of others’ personal data without permission.</li>
                  <li>No recording of sessions unless all parties have provided consent.</li>
                </ul>

                <h2>9. User Content &amp; Community Areas</h2>
                <p>If you post content (e.g., comments, forum posts), you grant Joyfullminds a worldwide, non-exclusive, royalty-free license to use, reproduce, and display such content for operating and improving the Services. Post only content you have rights to share and that complies with law.</p>

                <h2>10. Intellectual Property</h2>
                <p>All text, graphics, logos, trademarks, software, and other materials on the Services are owned by Joyfullminds or its licensors and are protected by law. You may not copy, modify, distribute, or create derivative works without prior written consent.</p>

                <h2>11. Third-Party Services &amp; Links</h2>
                <p>The Services may contain links to third-party sites or integrate with third-party tools. Joyfullminds is not responsible for their content or practices. Your use of such sites is subject to their terms and privacy policies.</p>

                <h2>12. Disclaimers</h2>
                <p>The Services are provided on an “as is” and “as available” basis without warranties of any kind, express or implied, including fitness for a particular purpose, non-infringement, or availability.</p>

                <h2>13. Limitation of Liability</h2>
                <p>To the maximum extent permitted by law, Joyfullminds shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or loss of data, profits, or goodwill, arising out of your use of the Services.</p>

                <h2>14. Indemnification</h2>
                <p>You agree to indemnify and hold harmless Joyfullminds, its affiliates, and personnel from any claims, damages, liabilities, and expenses arising from your breach of these Terms or misuse of the Services.</p>

                <h2>15. Suspension &amp; Termination</h2>
                <p>We may suspend or terminate access for violations of these Terms or for operational or legal reasons. You may stop using the Services at any time. Provisions that survive termination include intellectual property, disclaimers, limitation of liability, and indemnity.</p>

                <h2>16. Changes to the Terms</h2>
                <p>We may update these Terms from time to time by posting a revised version on the Website. Continued use of the Services after the effective date constitutes acceptance of the updated Terms.</p>

                <h2>17. Governing Law &amp; Jurisdiction</h2>
                <p>These Terms are governed by the laws of India. Courts in Pathankot, Punjab shall have exclusive jurisdiction.</p>

                <h2>18. Contact</h2>
                <p>Questions about these Terms: <a href="mailto:support@joyfullminds.com">support@joyfullminds.com</a></p>

              </div>
            </Col>
          </Row>

        </Container>
      </section>

    </>
  );
};

export default Terms;
